import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="inicio" className="flex min-h-[calc(100svh-2.75rem)] items-center bg-brand-cream px-4 py-8 text-center sm:py-12" data-id="element-82" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center" data-id="element-83" data-mp="28u4qux3b3wq6">
        <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-brand-terra sm:text-[11px]" data-id="element-84" data-mp="30k97ckny3zm4">
          El pack completo para docentes de Arte en Argentina
        </p>
        <h1 className="mt-4 max-w-3xl text-[1.85rem] font-semibold leading-[1.1] tracking-tight text-brand-navy sm:text-[2.75rem] lg:text-[3.25rem]" data-id="element-85" data-mp="2rs7a0v96azg2">
          Enseñá un año entero de{' '}
          <span className="italic text-brand-terra" data-id="element-86" data-mp="3k9te7pkh2xri">Arte</span> con solo 5
          minutos de preparación
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-[13px] leading-relaxed text-brand-gray sm:mt-5 sm:text-base" data-id="element-87" data-mp="2fgjzuynrjop6">
          Más de 2.000 docentes argentinos ya dejaron de improvisar. Llegá a
          cada clase con todo listo para enseñar, crear y transformar.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/ptVBRcPdq68MW91TiGfiYY/ChatGPT_Image_15_sept_2026,_12_43_39.png" alt="Pack Arte Lista: 12 tomos anillados de primaria y secundaria, actividades en pantalla y tablet, y los 5 bonos incluidos" className="mx-auto my-5 max-h-[32svh] w-auto max-w-full object-contain sm:my-7 sm:max-h-[38svh]" data-id="element-88" data-mp="2kev8j62bnt5t" />
        <CTAButton data-id="element-89" data-mp="335385e6tc1h9">Quiero el Pack Arte Lista</CTAButton>
        <p className="mt-4 text-[11px] font-medium text-brand-gray sm:text-xs" data-id="element-90" data-mp="336e812x50p33">
          Descarga inmediata{' '}
          <span className="px-1.5 text-brand-gold" aria-hidden="true" data-id="element-91" data-mp="1dqeu78ikqbh4">
            ·
          </span>
          Sin suscripción
          <span className="px-1.5 text-brand-gold" aria-hidden="true" data-id="element-92" data-mp="38tb9jp8ec2mx">
            ·
          </span>
          Acceso de por vida
        </p>
      </motion.div>
    </section>;
}